import React from "react";
import { FaCamera, FaFilePdf } from "react-icons/fa";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

interface ApplicationDetails {
  traderName: string;
  applicantType: string;
  registeredWithAPMC: string;
  licensePeriod: string;
  licenseFee: string;
  paymentStatus: string;
  applicationStatus: string;
  downloadLicense: string;
  licenseValidUpto:string;
}

interface AddressData {
  address: string;
  post: string;
  taluka: string;
  district: string;
}
interface UserAddress {
  address: string;
  post: string;
  taluka: string;
  district: string;
}

interface OfficeAddress {
  address: string;
  post: string;
  taluka: string;
  district: string;
}

interface OfficeDetails {
  panCardNo: string;
  electionCardNo: string;
  registeredEmail: string;
  mobileNo: string;
}
interface Representative {
  id: number;
  name: string;
  age: number;
  address: string;
}
interface Director {
  id: number;
  name: string;
  age: number;
  address: string;
}

const guarantorsData = [
  { name: "Puneet singh", address: "123 Street, NY", panCard: "ABCDE1234F" },
  { name: "Braveer singh", address: "456 Avenue, LA", panCard: "XYZ987654P" },
  { name: "Isha Tyagi", address: "789 Boulevard, TX", panCard: "LMN56789Q" },
];

const Approved: React.FC = () => {
  const [application, setApplication] = useState<ApplicationDetails | null>(
    null
  );
  const [directors, setDirectors] = useState<Director[]>([]);
  const [addressData, setAddressData] = useState<AddressData | null>(null);
  const [userAddress, setUserAddress] = useState<UserAddress | null>(null);
  const [officeAddress, setOfficeAddress] = useState<OfficeAddress | null>(
    null
  );
  const [officeDetails, setOfficeDetails] = useState<OfficeDetails | null>(
    null
  );
  const [representatives, setRepresentatives] = useState<Representative[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const [uploadedFiles, setUploadedFiles] = useState<Record<string, string>>({});


  const handleFileChange = ( e: React.ChangeEvent<HTMLInputElement>, 
    index: number, 
    type: string) => {
    const file = e.target.files?.[0];
    if (file) {
      setUploadedFiles((prev) => ({
        ...prev,
        [`${index}-${type}`]: URL.createObjectURL(file),
      }));
    }
  };

  useEffect(() => {
    const getApplicationDetails = async () => {
      try {
        // const data = await fetchApplicationDetails(); // Fetch application details from API
        // setApplication(data);
      } catch (err) {
        setError("Failed to load application details");
      } finally {
        setLoading(false);
      }
    };

    getApplicationDetails();
  }, []);

  useEffect(() => {
    const fetchAddress = async () => {
      try {
        // const response = await axios.get(apiUrl);
        //setAddressData(response.data);
      } catch (err) {
        setError("Failed to fetch address data.");
      } finally {
        setLoading(false);
      }
    };

    fetchAddress();
  }, []);
  useEffect(() => {
    const fetchAddress = async () => {
      try {
        //const response = await axios.get<UserAddress>(apiUrl);
        // setUserAddress(response.data);
      } catch (err) {
        setError("Failed to fetch address data.");
      } finally {
        setLoading(false);
      }
    };

    fetchAddress();
  }, []);

  useEffect(() => {
    const fetchOfficeData = async () => {
      try {
        // const response = await axios.get<{ address: OfficeAddress; details: OfficeDetails }>(apiUrl);
        //setOfficeAddress(response.data.address);
        //setOfficeDetails(response.data.details);
      } catch (err) {
        setError("Failed to fetch office details.");
      } finally {
        setLoading(false);
      }
    };

    fetchOfficeData();
  }, []);
  return (
    <div>
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">Track Application Status </h3>
                {/* <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Horizontal Form</li>
                  </ul> */}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Application Details</h5>
                </div>
                <div className="card-body">
                  {loading ? (
                    <p>Loading application details...</p>
                  ) : error ? (
                    <p className="text-danger">{error}</p>
                  ) : (
                    <div className="table-responsive">
                      {/* First Table */}
                      <table className="table table-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>Trader Name</th>
                            <th>Applicant Type</th>
                            <th>Registered with APMC</th>
                            <th>Period Of License</th>
                          </tr>
                        </thead>
                        <tbody>
                          {application ? (
                            <tr>
                              <td>{application.traderName}</td>
                              <td>{application.applicantType}</td>
                              <td>{application.registeredWithAPMC}</td>
                              <td>{application.licensePeriod}</td>
                            </tr>
                          ) : (
                            <tr>
                              <td colSpan={4} className="text-center">
                                No application details available.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      {/* Second Table */}
                      <table className="table table-nowrap mb-0 mt-3">
                        <thead>
                          <tr>
                            <th>License Fee</th>
                            <th>Payment Status</th>
                            <th>Application Status</th>
                            <th>Download License</th>
                            <th>License Valid Upto</th>
                          </tr>
                        </thead>
                        <tbody>
                          {application ? (
                            <tr>
                              <td>{application.licenseFee}</td>
                              <td>{application.paymentStatus}</td>
                              <td>{application.applicationStatus}</td>
                              <td>{application.downloadLicense}</td>
                              <td>{application.licenseValidUpto}</td>
                            </tr>
                          ) : (
                            <tr>
                              <td colSpan={5} className="text-center">
                                No application details available.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div>
                    <h5 className="mb-2">Current Address:</h5>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>Address</th>
                              <th>Post</th>
                              <th>Taluka</th>
                              <th>District</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : error ? (
                              <tr>
                                <td
                                  colSpan={4}
                                  className="text-center text-danger"
                                >
                                  {error}
                                </td>
                              </tr>
                            ) : addressData ? (
                              <tr>
                                <td>{addressData.address}</td>
                                <td>{addressData.post}</td>
                                <td>{addressData.taluka}</td>
                                <td>{addressData.district}</td>
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No address details available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h5 className="mb-2">Permanent Address:</h5>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>Address</th>
                              <th>Post</th>
                              <th>Taluka</th>
                              <th>District</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : error ? (
                              <tr>
                                <td
                                  colSpan={4}
                                  className="text-center text-danger"
                                >
                                  {error}
                                </td>
                              </tr>
                            ) : userAddress ? (
                              <tr>
                                <td>{userAddress.address}</td>
                                <td>{userAddress.post}</td>
                                <td>{userAddress.taluka}</td>
                                <td>{userAddress.district}</td>
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No address details available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <h5 className="mb-2">Registered Office Address:</h5>

                    {/* Office Address Table */}
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>Address</th>
                              <th>Post</th>
                              <th>Taluka</th>
                              <th>District</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : error ? (
                              <tr>
                                <td
                                  colSpan={4}
                                  className="text-center text-danger"
                                >
                                  {error}
                                </td>
                              </tr>
                            ) : officeAddress ? (
                              <tr>
                                <td>{officeAddress.address}</td>
                                <td>{officeAddress.post}</td>
                                <td>{officeAddress.taluka}</td>
                                <td>{officeAddress.district}</td>
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No office address details available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* Office Details Table */}
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>Pan Card No.</th>
                              <th>Election Card No.</th>
                              <th>Registered Email Id</th>
                              <th>Mobile No.</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : error ? (
                              <tr>
                                <td
                                  colSpan={4}
                                  className="text-center text-danger"
                                >
                                  {error}
                                </td>
                              </tr>
                            ) : officeDetails ? (
                              <tr>
                                <td>{officeDetails.panCardNo}</td>
                                <td>{officeDetails.electionCardNo}</td>
                                <td>{officeDetails.registeredEmail}</td>
                                <td>{officeDetails.mobileNo}</td>
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No office details available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h5 className="mb-2">Representatives or Assistants:</h5>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>Sr No.</th>
                              <th>Name</th>
                              <th>Age (Years)</th>
                              <th>Address</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            ) : error ? (
                              <tr>
                                <td
                                  colSpan={4}
                                  className="text-center text-danger"
                                >
                                  {error}
                                </td>
                              </tr>
                            ) : representatives.length > 0 ? (
                              representatives.map((rep, index) => (
                                <tr key={rep.id}>
                                  <td>{index + 1}.</td>
                                  <td>{rep.name}</td>
                                  <td>{rep.age}</td>
                                  <td>{rep.address}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No representatives available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div>
      <h5 className="mb-2">Directors/Partners/Members:</h5>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-nowrap mb-0">
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Name</th>
                <th>Age (Years)</th>
                <th>Address</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="text-center">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan={4} className="text-center text-danger">{error}</td>
                </tr>
              ) : directors.length > 0 ? (
                directors.map((director, index) => (
                  <tr key={director.id}>
                    <td>{index + 1}.</td>
                    <td>{director.name}</td>
                    <td>{director.age}</td>
                    <td>{director.address}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">No directors available.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
                  <div>
                    <h5 className="mb-2">Enclosures:</h5>
                    <div className="card-body">
                      <div className="card-body">
                        <div className="table-responsive">
                          <div className="flex items-center gap-3 p-2 border rounded-md bg-gray-100">
                            <i className="fa fa-file-pdf text-red-600 text-2xl"></i>

                            <a
                              href="/path-to-your-pdf.pdf"
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-600 font-semibold hover:underline"
                            >
                              View PDF Document
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
      <h5 className="mb-2">Guarantor Details:</h5>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table text-nowrap">
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Name</th>
                <th>Address</th>
                <th>PAN Card No.</th>
                <th>Photo</th>
                <th>Signature</th>
                <th>Declaration</th>
              </tr>
            </thead>
            <tbody>
              {guarantorsData.map((guarantor, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{guarantor.name}</td>
                  <td>
                    <span className="badge bg-soft-primary">{guarantor.address}</span>
                  </td>
                  <td>{guarantor.panCard}</td>
                  {["photo", "signature", "declaration"].map((type) => (
                    <td key={type}>
                      <label className="cursor-pointer flex items-center gap-2">
                        <i className="fa-solid fa-image"></i>
                        <input
                          type="file"
                          accept="image/*"
                          className="d-none"
                          onChange={(e) => handleFileChange(e, index, type)}
                        />
                      </label>
                      {uploadedFiles[`${index}-${type}`] && (
                        <img
                          // src={uploadedFiles[`${index}-${type}`]}
                          alt={`${type} preview`}
                          className="img-thumbnail mt-2"
                          width="50"
                        />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Approved;
